import React from "react";
import { Box, Container, useTheme, useMediaQuery } from "@mui/material";
import Navigation from "./dashboard/Navigation";
import { ElectricBolt as SolarIcon } from "@mui/icons-material";

// In your menu items array
const menuItems = [
  // ...existing menu items...
  {
    text: "Own A Solar",
    icon: <SolarIcon />,
    path: "/solar",
    description: "Get a free 1KW Solar Power System",
  },
  // ...existing menu items...
];

const Layout = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <Navigation />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { md: `calc(100% - 250px)` },
          ml: { md: "250px" },
          mt: isMobile ? 8 : 0,
        }}
      >
        <Container maxWidth="lg">{children}</Container>
      </Box>
    </Box>
  );
};

export default Layout;
